export default `<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor">
<path
  class="st0"
  d="M0.5,22.8h6.2v-7.8H0.5V22.8z M1.3,15.9h4.6V22H1.3V15.9z"
/>
<path class="st0" d="M8.9,22.8h6.2V0.9H8.9V22.8z M9.7,1.7h4.6V22H9.7V1.7z" />
<path
  class="st0"
  d="M17.4,9.4v13.4h6.2V9.4H17.4z M22.8,22h-4.6V10.2h4.6V22z"
/>
</g></svg>`;
